export default __webpack_public_path__ + "static/media/logo.169e5371.svg";